import { HighAuthLogin } from '@tencent/wphk-act-base-framework';
import { showToast } from '@tencent/wphk-components-toast';
import { ref } from 'vue-demi';
import { i18n } from '../i18n';

const LOGIN_ACTID = 'wphk_2024';
const ACT_MODULE_NAME = 'c2c';

export const useHighLogin = () => {
  const highAuthLogin = new HighAuthLogin(LOGIN_ACTID, ACT_MODULE_NAME);
  const highAuthLoginBackData = ref<any>(null);
  /** 前往高授权 */
  async function onGoHighAuthLogin(data) {
    showToast({
      title: `${i18n('授權中')}...`,
      duration: 1000,
    });
    await highAuthLogin.goHighAuthLogin(data);
  }
  /** 是否需要高授权&如果需要则进行登录 */
  async function checkHighAndLogin(data) {
    const isNeedLoginVal = await highAuthLogin.checkIsNeedHighAuthLogin();
    if (isNeedLoginVal) {
      await onGoHighAuthLogin(data);
    }
  }
  /** 设置高授权回来数据 */
  function setHighAuthLoginBackData(data) {
    highAuthLoginBackData.value = data;
  }
  return {
    highAuthLogin,
    checkHighAndLogin,
    highAuthLoginBackData,
    setHighAuthLoginBackData,
  };
};
